export default "__VITE_ASSET__TY2XgVNs__"